let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
for (const item of items) {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
    });
}

// Clicking a top-level menu name (e.g. "Funko") opens its collection on devices that can hover;
// touch devices keep tap-to-open and use the "Shop all" link inside the dropdown.
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.header__inline-menu summary[data-href]').forEach((summary) => {
        summary.addEventListener('click', (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey) return;
            event.preventDefault();
            window.location.href = summary.dataset.href;
        });
    });
}
